import { Component, OnInit, Input } from '@angular/core';
import { OtEvent, Teacher } from 'src/app/domain/ot-event';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TeacherProfileComponent } from 'src/app/shared';

@Component({
  selector: 'app-ot-event-info',
  templateUrl: './ot-event-info.component.html',
  styleUrls: ['./ot-event-info.component.scss']
})
export class OtEventInfoComponent implements OnInit {

  @Input()
  public otEvent: OtEvent;

  @Input()
  public changable = true;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  public showTeacherProfile(teacher: Teacher): void {
    const modalRef = this.modalService.open(TeacherProfileComponent);
    modalRef.componentInstance.teacher = teacher;
  }
}
